import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

//SERVICE
import { LandingCultureESPService } from "./landingculture_esp.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import * as $ from 'jquery';
//import { productos } from './landing.productos';
@Component({
  selector: 'app-landingculturetr',
  templateUrl: './landingculture_esp.component.html',
  styleUrls: ['./landingculture_esp.component.scss'],
  animations : fuseAnimations
})
export class Landingculture_espComponent implements OnInit {
  origen: any;
  producto: any;
  userData:any;
  itbmUser:boolean=false;
  private _unsubscribeAll: Subject<any>;
  constructor(
    private activatedRoute:ActivatedRoute,
    private http:HttpClient,
    private landingService : LandingCultureESPService,

    private router: Router,
    private wizardService: WizardService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
      this._unsubscribeAll = new Subject();
      lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      //this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaVideo(this.translateSrv.currentLang); });
      if(localStorage.getItem('userBypass')){
        this.userData=JSON.parse(localStorage.getItem('userBypass'));
          console.log(this.userData.level);
        if(this.userData.level==2){
          this.itbmUser=true;
        }
      }
   }

  ngOnInit() {
    this.activatedRoute.data.subscribe(params => {
      console.log(params);
        this.origen = params;
          /*productos.forEach( (producto) => {
          if(producto.id == this.origen.producto){
            this.producto = producto;
          }
        });*/
    });
    this.productosCulture();
  }
  productosContratadosInter : backInter.infoProductos;
 
  productosAsignados: any[] = [];
  tipoCultureAudit:any;
  cargando:boolean=true;
  titleProducto:any;
  productosCulture(){
    this.productosAsignados=[];
    this.landingService.getProductosEmpresa().subscribe((respuesta:backInter.infoProductos) => {
      this.productosContratadosInter = respuesta;
      console.log("Productos culture audit");
      console.log(this.productosContratadosInter.productosCultureAuditV2);
      console.log(this.origen);
      switch(this.origen.producto){
        case "culture_esp1":
          this.productosAsignados=[];
          this.titleProducto='WIZARD.LANDING.INST-ESP.TITULO1';
          this.productosContratadosInter.productosCultureAudit.forEach(producto => {
            
              this.productosAsignados.push(producto);
            
          });
        break;

        case "culture_esp2":
          this.productosAsignados=[];
          this.titleProducto='WIZARD.LANDING.INST-ESP.TITULO2';
          this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
            if(producto.tipo == 2){
             
              this.productosAsignados.push(producto);
            }
          });
        break;
        case "culture_esp3":
          console.log("entro dude");
          this.productosAsignados=[];
          this.titleProducto='WIZARD.LANDING.INST-ESP.TITULO3';
          this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
            if(producto.tipo == 9){
              this.productosAsignados.push(producto);
            }
          });
        break;

      }
      console.log(this.productosAsignados);
      this.cargando=false;


    }, error => {
      console.log("error", error);
    })
  }
  navigateTo(idCulture){
    console.log("entro");
    console.log(this.productosContratadosInter.productosCultureAuditV2);
    let pos=0;
    this.productosContratadosInter.productosCultureAuditV2.forEach(producto => {
      if(producto.idCulture == idCulture){
        console.log("Pos "+pos);
        localStorage.setItem("Posculture",''+pos);
        this.router.navigate(['/cultureAudit']);
      }
      pos++;
    });

    this.productosContratadosInter.productosCultureAudit.forEach(producto => {
      if(producto.idCulture == idCulture){
        console.log("Pos "+pos);
        localStorage.setItem("Posculture",''+pos);
        this.router.navigate(['/Culture']);
      }
      pos++;
    });
    //this.router.navigate(['/cultureAudit']);
  }

}
